/**
 * Small typed wrapper over @capacitor/preferences for the few values the app
 * caches locally (last-used login email for prefill, etc). Works on web too
 * (Preferences falls back to localStorage in the web runtime).
 */
import { Preferences } from '@capacitor/preferences';

const KEYS = {
  lastEmail: 'mitang.lastEmail',
} as const;

export async function setLastEmail(email: string): Promise<void> {
  await Preferences.set({ key: KEYS.lastEmail, value: email });
}

export async function getLastEmail(): Promise<string | null> {
  const { value } = await Preferences.get({ key: KEYS.lastEmail });
  return value ?? null;
}
